import { type SubItemForm } from './subItemTypes';

export interface LineItemData {
  id: string;
  category: string;
  description: string;
  totalCost: number;
  subItems: SubItemForm[];
  templateId?: string;
  itemDate?: string;
  /** Top-level sort order for interleaving with projects. */
  sortOrder?: number;
}

export interface ProjectData {
  id: string;
  name: string;
  sortOrder: number;
  lineItems: LineItemData[];
}

export function DragOverlayContent({ item }: { item: LineItemData }) {
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 border border-blue-300 rounded-md shadow-lg text-xs max-w-[280px]">
      {item.category && (
        <span className="bg-white text-gray-700 px-1.5 py-0.5 rounded border border-gray-200 truncate max-w-[100px]">
          {item.category}
        </span>
      )}
      <span className="text-gray-600 truncate">{item.description || 'Untitled'}</span>
      <span className="text-gray-700 font-semibold whitespace-nowrap ml-auto">
        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.totalCost)}
      </span>
    </div>
  );
}
